import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth'
import Layout from '@/components/layout/Layout'
import VersionWatcher from '@/components/VersionWatcher'
import ModalConfirmarExclusao from '@/components/ModalConfirmarExclusao'
import LoginPage from '@/pages/Login'
import DashboardPage from '@/pages/Dashboard'
import VisaoDonoPageOld from '@/pages/VisaoDono'
import ProdutosPage from '@/pages/Produtos'
import PessoasPage from '@/pages/Pessoas'
import ComodatoPage from '@/pages/Comodato'
import RHPage from '@/pages/RH'
import RoteirizacaoPage from '@/pages/Roteirizacao'
import TabelasPrecoPage from '@/pages/TabelasPreco'
import CampanhasDescontoPage from '@/pages/CampanhasDesconto'
import AnaliseVendasPage from '@/pages/AnaliseVendasPage'
import CurvaABCPage from '@/pages/CurvaABC'
import ConfigEmpresaPage from '@/pages/ConfigEmpresa'
import FiliaisPage from '@/pages/Filiais'
import FiscalPage from '@/pages/Fiscal'
import NFePropriaPage from '@/pages/NFePropria'
import ApuracaoDifalPage from '@/pages/ApuracaoDifal'
import IndMaquinasPage from '@/pages/IndMaquinas'
import IndMoldesPage from '@/pages/IndMoldes'
import IndEtapasPage from '@/pages/IndEtapas'
import IndMateriasPrimasPage from '@/pages/IndMateriasPrimas'
import IndFichasPage from '@/pages/IndFichas'
import IndFichaEditorPage from '@/pages/IndFichaEditor'
import VendasPage from '@/pages/Vendas'
import SeparacaoPage from '@/pages/Separacao'
import EmbalagemPage from '@/pages/Embalagem'
import OndaSeparacaoPage from '@/pages/OndaSeparacao'
import OndaBipagemPage from '@/pages/OndaBipagem'
import OndasPage from '@/pages/Ondas'
import NovoPedidoPage from '@/pages/NovoPedido'
import LayoutPedidoPage from '@/pages/LayoutPedido'
import LayoutMapaPage from '@/pages/LayoutMapa'
import LayoutRomaneioPage from '@/pages/LayoutRomaneio'
import DecisoesQualidadePage from '@/pages/DecisoesQualidade'
import TrocasPage from '@/pages/Trocas'
import ImportarPedidoMLPage from '@/pages/ImportarPedidoML'
import MetricasNegocioMLPage from '@/pages/vendas/MetricasNegocioML'
import VendasAoVivoMLPage from '@/pages/vendas/VendasAoVivoML'
import PDVPage from '@/pages/PDV'
import PlanoContasPage from '@/pages/PlanoContas'
import DREPage from '@/pages/DRE'
import { FluxoCaixaPage as FluxoCaixaInteligente, PosicaoEstoquePage, VisaoDonoPage } from '@/pages/DashboardsPage'
import FluxoCaixaPageOld from '@/pages/FluxoCaixaPage'
import ProdutosPorCategoriaPage from '@/pages/ProdutosPorCategoriaPage'
import RelatorioEstoquePage from '@/pages/RelatorioEstoquePage'
import FinanceiroPage from '@/pages/FinanceiroPage'
import AnaliseCreditoPage from '@/pages/AnaliseCredito'
import CreditoClientesPage from '@/pages/CreditoClientesPage'
import { RelDevolucoes, RelCreditoCliente } from '@/pages/RelatoriosExtras'
import IntegracaoSerasaPage from '@/pages/IntegracaoSerasa'
import MapaCargasPage from '@/pages/MapaCargas'
import LojaHomePage from '@/pages/loja/LojaHome'
import PainelDono from '@/pages/PainelDono'
import LojaProdutoPage from '@/pages/loja/LojaProduto'
import LojaLoginPage from '@/pages/loja/LojaLogin'
import LojaCarrinhoPage from '@/pages/loja/LojaCarrinho'
import LojaCheckoutPage from '@/pages/loja/LojaCheckout'
import LojaRastreioPage from '@/pages/loja/LojaRastreio'
import LojaMeusPedidosPage from '@/pages/loja/LojaMeusPedidos'
import MinhaLojaPage from '@/pages/MinhaLoja'
import UsuariosPage from '@/pages/Usuarios'
import PerfisPage from '@/pages/Perfis'
import DepositosPage from '@/pages/Depositos'
import EntradaEstoquePage from '@/pages/EntradaEstoque'
import AjusteEstoquePage from '@/pages/AjusteEstoque'
import TransferenciasPage from '@/pages/Transferencias'
import {
  ContasBancariasPage, TesourariaPage, LancamentosPage, ConciliacaoPage,
} from '@/pages/FinanceiroCompleto'
import LancamentosPro from '@/pages/LancamentosPro'
import BorderosPage, { BorderoDetalhePage } from '@/pages/Borderos'
import LinhasDigitaveisPage from '@/pages/LinhasDigitaveis'
import { ConfigFormasPgtoPage } from '@/pages/CaixaConfig'
import CaixaSessoesPage from '@/pages/CaixaSessoes'
import ChequesCarteiraPage from '@/pages/ChequesCarteira'
import CorrecaoFormaRecebimentoPage from '@/pages/CorrecaoFormaRecebimento'
import FormasPagamentoPage from '@/pages/FormasPagamento'
import EmissaoBoletosPage from '@/pages/EmissaoBoletos'
import RetornosBancariosPage from '@/pages/RetornosBancarios'
import ConfigBoletoPage from '@/pages/ConfigBoleto'
import PagamentosLotePage from '@/pages/PagamentosLote'
import ConciliacaoBancaria from '@/pages/ConciliacaoBancaria'
import ConciliacaoV2 from '@/pages/ConciliacaoV2'
import MercadoPagoPage from '@/pages/MercadoPago'
import {
  SuperAdminDashboard, SuperAdminEmpresas, SuperAdminBilling, IAConfigPage, SuperAdminGrupos,
} from '@/pages/SuperAdmin'
import ComprasPage from '@/pages/Compras'
import NFEntradasPage from '@/pages/NFEntradas'
import DFeEntradaPage from '@/pages/DFeEntrada'
import IntercompanyPage from '@/pages/Intercompany'
import {
  EstoquePage, MarketplacePage,
  FichasTecnicasPage, ConfiguracoesPage,
} from '@/pages/SimplePages'
import CategoriasPage from '@/pages/Categorias'
import ColaboradoresPage from '@/pages/Colaboradores'
import EquipamentosPage from '@/pages/Equipamentos'
import MotivosDevolucaoPage from '@/pages/MotivosDevolucao'
import GradesPage from '@/pages/cadastros/Grades'
import RegrasImpostoPage from '@/pages/cadastros/RegrasImposto'
import OrdensServicoPage from '@/pages/OrdensServico'
import NovaOSPage from '@/pages/NovaOS'
import OSDetalhePage from '@/pages/OSDetalhe'
import BPMPage from '@/pages/BPM'
import BPMInstanciaPage from '@/pages/BPMInstancia'
import BPMProcessoEditor from '@/pages/BPMProcessoEditor'
import BPMDesignerPage from '@/pages/BPMDesigner'
import IntranetPage from '@/pages/Intranet'
import OrdensProducaoPage from '@/pages/OrdensProducao'
import OrdemProducaoDetalhe from '@/pages/OrdemProducaoDetalhe'
import CargaProducaoPage from '@/pages/CargaProducaoPage'
import DashboardIndustrial from '@/pages/DashboardIndustrial'
import AndonIndustrial from '@/pages/AndonIndustrial'
import LotesPage from '@/pages/Lotes'
import ManutencaoPage from '@/pages/Manutencao'
import ExpedicaoVeiculosPage from '@/pages/ExpedicaoVeiculos'
import ExpedicaoMotoristasPage from '@/pages/ExpedicaoMotoristas'
import ExpedicaoRotasPage from '@/pages/ExpedicaoRotas'
import ExpedicaoMDFePage from '@/pages/ExpedicaoMDFe'
import CargasDistribuicaoPage from '@/pages/CargasDistribuicao'
import FiscalLivrosPage from '@/pages/FiscalLivros'
import TributacaoProdutos from '@/pages/TributacaoProdutos'
// [PORT-MAURITI 2026-08-11] Reforma Tributária (CBS/IBS/IS — LC 214/2025)
import ReformaTributaria from '@/pages/ReformaTributaria'
import CfopPage from '@/pages/Cfop'
import NotaAvulsaPage from '@/pages/NotaAvulsa'
import MensagensFiscais from '@/pages/MensagensFiscais'
import InventariosListPage from '@/pages/inventario/InventariosListPage'
import InventarioNovoPage from '@/pages/inventario/InventarioNovoPage'
import InventarioDetalhePage from '@/pages/inventario/InventarioDetalhePage'
import MobileLayout from '@/components/mobile/MobileLayout'
import InventariosMobilePage from '@/pages/mobile/InventariosMobilePage'
import InventarioDetalheMobilePage from '@/pages/mobile/InventarioDetalheMobilePage'
import ComercialMetasPage from '@/pages/ComercialMetasPage'
import VendaGeralPage from '@/pages/VendaGeralPage'
import PainelAuditoriaPage from '@/pages/PainelAuditoriaPage'
import RotasComercialPage from '@/pages/RotasComercialPage'
import VendaRecebimentosPage from '@/pages/VendaRecebimentosPage'
import ResumoFinanceiroMLPage from '@/pages/ResumoFinanceiroML'
import RelatoriosGerenciaisPage from '@/pages/RelatoriosGerenciaisPage'
import RelatorioGerencialView from '@/pages/RelatorioGerencialView'
import GiroProdutosPage from '@/pages/GiroProdutosPage'
import SugestoesCompraPage from '@/pages/SugestoesCompraPage'
import ComissaoVendedorPage from '@/pages/ComissaoVendedorPage'
import SACPage from '@/pages/SAC'
import SACConfigPage from '@/pages/SACConfig'
import ControladoriaPage from '@/pages/Controladoria'
import KioskRoot from '@/pages/Kiosk/KioskRoot'
import IndicadoresIndustriaisPage from '@/pages/IndicadoresIndustriais'
import IndTurnosPage from '@/pages/IndTurnos'
import AjudaPage from '@/pages/Ajuda'
import SOSPanelPage from '@/pages/SOSPanel'
import ImprimirOPsPage from '@/pages/ImprimirOPs'
import MobileOperadorPage from '@/pages/MobileOperador'
import MobileOPApontarPage from '@/pages/MobileOPApontar'
import MobileLoginPage from '@/pages/MobileLogin'
import MobileMaquinaFilaPage from '@/pages/MobileMaquinaFila'
import EntregadorLogin from '@/pages/entregador/EntregadorLogin'
import PontoApp from '@/pages/PontoApp'
import EntregadorCargas from '@/pages/entregador/EntregadorCargas'
import EntregadorCarga from '@/pages/entregador/EntregadorCarga'
import FreezerPreCadastroPage from '@/pages/comodato/FreezerPreCadastro'
import OrcamentosPage from '@/pages/Orcamentos'
import NovoOrcamentoPage from '@/pages/NovoOrcamento'
import OrcamentoDetalhePage from '@/pages/Orcamentodetalhe'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuth()
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

function RequireSuper({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  if (user?.perfil !== 'super_admin') return <Navigate to="/" replace />
  return <>{children}</>
}

export default function App() {
  const loadFromStorage = useAuth((s) => s.loadFromStorage)
  const refreshUser = useAuth((s) => s.refreshUser)
  useEffect(() => {
    loadFromStorage()
    // Sincroniza RBAC (nivel/permissoes) do usuário logado no boot
    if (localStorage.getItem('pain_token')) refreshUser()
  }, [loadFromStorage, refreshUser])

  return (
    <>
    <VersionWatcher />
    {/* FEATURE 02/07: modal global de confirmação de exclusão (senha gerente/admin/super) */}
    <ModalConfirmarExclusao />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pdv" element={<RequireAuth><PDVPage canal="balcao" /></RequireAuth>} />
      {/* FEATURE 30/06: PDV-online = mesmo PDV, caixa separado (canal 'online') */}
      <Route path="/pdv-online" element={<RequireAuth><PDVPage canal="online" /></RequireAuth>} />
      <Route path="/industrial/andon" element={<RequireAuth><AndonIndustrial /></RequireAuth>} />
      {/* KIOSK chao de fabrica — rota PUBLICA, autentica via X-Machine-Token */}
      <Route path="/kiosk" element={<KioskRoot />} />
      <Route path="/kiosk/:token" element={<KioskRoot />} />
      {/* MOBILE OPERADOR — login dedicado + lista + scanner */}
      <Route path="/m/login" element={<MobileLoginPage />} />
      <Route path="/m/operador" element={<MobileOperadorPage />} />
      <Route path="/m/maquina/:token" element={<MobileMaquinaFilaPage />} />
      <Route path="/m/op/:token" element={<MobileOPApontarPage />} />
      {/* APP DO ENTREGADOR (motorista) — login CPF+PIN, cargas, entregas */}
      <Route path="/m/freezer" element={<FreezerPreCadastroPage />} />
      <Route path="/m/ponto" element={<PontoApp />} />
      <Route path="/m/entregador" element={<EntregadorLogin />} />
      <Route path="/m/entregador/cargas" element={<EntregadorCargas />} />
      <Route path="/m/entregador/carga/:id" element={<EntregadorCarga />} />
      {/* IMPRESSÃO de OPs com QR (popup) */}
      <Route path="/industrial/ordens/imprimir" element={<RequireAuth><ImprimirOPsPage /></RequireAuth>} />
      {/* PAINEL DO DONO (público, sem login — validação) */}
      <Route path="/painel" element={<PainelDono />} />
      {/* LOJA PUBLICA (fora do Layout admin) */}
      <Route path="/loja/:slug" element={<LojaHomePage />} />
      <Route path="/loja/:slug/produto/:sku" element={<LojaProdutoPage />} />
      <Route path="/loja/:slug/login" element={<LojaLoginPage />} />
      <Route path="/loja/:slug/carrinho" element={<LojaCarrinhoPage />} />
      <Route path="/loja/:slug/checkout" element={<LojaCheckoutPage />} />
      <Route path="/loja/:slug/rastreio/:token" element={<LojaRastreioPage />} />
      <Route path="/loja/:slug/minha-conta" element={<LojaMeusPedidosPage />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/relatorios/visao-dono" element={<VisaoDonoPage />} />

        <Route path="/vendas" element={<VendasPage />} />
        <Route path="/vendas/novo" element={<NovoPedidoPage />} />
        <Route path="/vendas/layout-pedido" element={<LayoutPedidoPage />} />
        <Route path="/expedicao/layout-mapa" element={<LayoutMapaPage />} />
        <Route path="/expedicao/layout-romaneio" element={<LayoutRomaneioPage />} />
        <Route path="/vendas/decisoes-qualidade" element={<DecisoesQualidadePage />} />
        <Route path="/vendas/trocas" element={<TrocasPage />} />
        <Route path="/vendas/importar-ml" element={<ImportarPedidoMLPage />} />
        <Route path="/vendas/metricas" element={<MetricasNegocioMLPage />} />
        <Route path="/vendas/ao-vivo" element={<VendasAoVivoMLPage />} />
        <Route path="/comodato" element={<ComodatoPage />} />
        <Route path="/rh" element={<RHPage />} />
        <Route path="/roteirizacao" element={<RoteirizacaoPage />} />
        <Route path="/vendas/separacao" element={<OndaSeparacaoPage />} />
        <Route path="/vendas/ondas" element={<OndasPage />} />
        <Route path="/vendas/cargas/:id/separacao" element={<OndaBipagemPage />} />
        <Route path="/vendas/pedidos/:id/separacao" element={<SeparacaoPage />} />
        <Route path="/vendas/pedidos/:id/embalagem" element={<EmbalagemPage />} />

        <Route path="/cadastros/clientes" element={<PessoasPage tipo="cliente" />} />
        <Route path="/cadastros/fornecedores" element={<PessoasPage tipo="fornecedor" />} />
        <Route path="/cadastros/produtos" element={<ProdutosPage />} />
        <Route path="/cadastros/tabelas-preco" element={<TabelasPrecoPage />} />
        <Route path="/cadastros/regras-imposto" element={<RegrasImpostoPage />} />
        <Route path="/cadastros/campanhas-desconto" element={<CampanhasDescontoPage />} />
        <Route path="/relatorios/vendedores" element={<AnaliseVendasPage />} />
        <Route path="/relatorios/curva-abc" element={<CurvaABCPage />} />
        <Route path="/cadastros/categorias" element={<CategoriasPage />} />
        <Route path="/cadastros/vendedores" element={<ColaboradoresPage tipo="vendedor" />} />
        <Route path="/cadastros/tecnicos" element={<ColaboradoresPage tipo="tecnico" />} />
        <Route path="/cadastros/equipamentos" element={<EquipamentosPage />} />
        <Route path="/cadastros/motivos-devolucao" element={<MotivosDevolucaoPage />} />
        <Route path="/cadastros/grades" element={<GradesPage />} />

        <Route path="/estoque" element={<EstoquePage />} />
        <Route path="/estoque/entrada" element={<EntradaEstoquePage />} />
        <Route path="/estoque/ajuste" element={<AjusteEstoquePage />} />
        <Route path="/estoque/transferencias" element={<TransferenciasPage />} />
        <Route path="/estoque/inventarios" element={<InventariosListPage />} />
        <Route path="/estoque/inventarios/novo" element={<InventarioNovoPage />} />
        <Route path="/estoque/inventarios/:id" element={<InventarioDetalhePage />} />

        <Route path="/financeiro/venda-recebimentos" element={<VendaRecebimentosPage />} />
        <Route path="/financeiro/receber" element={<FinanceiroPage tipo="receber" />} />
        <Route path="/financeiro/pagar" element={<FinanceiroPage tipo="pagar" />} />
        <Route path="/financeiro/analise-credito" element={<AnaliseCreditoPage />} />
        <Route path="/financeiro/creditos" element={<CreditoClientesPage />} />
        <Route path="/financeiro/cheques" element={<ChequesCarteiraPage />} />
        <Route path="/financeiro/correcao-forma" element={<CorrecaoFormaRecebimentoPage />} />
        <Route path="/financeiro/formas-pagamento" element={<FormasPagamentoPage />} />
        <Route path="/financeiro/boletos" element={<EmissaoBoletosPage />} />
        <Route path="/financeiro/retornos" element={<RetornosBancariosPage />} />
        <Route path="/financeiro/config-boleto" element={<ConfigBoletoPage />} />
        <Route path="/financeiro/pagamentos-lote" element={<PagamentosLotePage />} />
        <Route path="/relatorios/devolucoes" element={<RelDevolucoes />} />
        <Route path="/relatorios/creditos-cliente" element={<RelCreditoCliente />} />

        <Route path="/financeiro/contas-bancarias" element={<ContasBancariasPage />} />
        <Route path="/financeiro/tesouraria" element={<TesourariaPage />} />
        <Route path="/financeiro/lancamentos" element={<LancamentosPro />} />
        <Route path="/financeiro/lancamentos-old" element={<LancamentosPage />} />
        <Route path="/financeiro/borderos" element={<BorderosPage />} />
        <Route path="/financeiro/borderos/:id" element={<BorderoDetalhePage />} />
        <Route path="/financeiro/linhas-digitaveis" element={<LinhasDigitaveisPage />} />
        <Route path="/financeiro/conciliacao" element={<ConciliacaoV2 />} />
        <Route path="/financeiro/conciliacao-extrato" element={<ConciliacaoBancaria />} />
        <Route path="/integracoes/mercadopago" element={<MercadoPagoPage />} />
        <Route path="/configuracoes/loja" element={<MinhaLojaPage />} />
        <Route path="/financeiro/plano-contas" element={<PlanoContasPage />} />
        <Route path="/financeiro/dre" element={<DREPage />} />
        <Route path="/financeiro/fluxo-caixa" element={<FluxoCaixaInteligente />} />
        <Route path="/relatorios/fluxo-caixa" element={<FluxoCaixaInteligente />} />
        <Route path="/relatorios/fluxo-caixa-old" element={<FluxoCaixaPageOld />} />
        <Route path="/relatorios/produtos-categoria" element={<ProdutosPorCategoriaPage />} />
        <Route path="/relatorios/estoque" element={<PosicaoEstoquePage />} />
        <Route path="/relatorios/estoque-old" element={<RelatorioEstoquePage />} />
        <Route path="/relatorios/visao-dono-old" element={<VisaoDonoPageOld />} />
        <Route path="/configuracoes/empresa" element={<ConfigEmpresaPage />} />
        <Route path="/configuracoes/filiais" element={<FiliaisPage />} />
        <Route path="/configuracoes/usuarios" element={<UsuariosPage />} />
        <Route path="/configuracoes/perfis" element={<PerfisPage />} />
        <Route path="/configuracoes/depositos" element={<DepositosPage />} />

        <Route path="/caixa/config-formas" element={<ConfigFormasPgtoPage />} />
        <Route path="/caixa/sessoes" element={<CaixaSessoesPage />} />

        <Route path="/fiscal" element={<FiscalPage />} />
        <Route path="/nfe-propria" element={<NFePropriaPage />} />
        <Route path="/apuracao-difal" element={<ApuracaoDifalPage />} />
        <Route path="/fiscal/livros" element={<FiscalLivrosPage />} />
        <Route path="/fiscal/tributacao-produtos" element={<TributacaoProdutos />} />
        <Route path="/fiscal/reforma" element={<ReformaTributaria />} />
        <Route path="/fiscal/cfop" element={<CfopPage />} />
        <Route path="/fiscal/nota-avulsa" element={<NotaAvulsaPage />} />
        {/* Mesma tela, abrindo direto numa nota — permite linkar do histórico
            de NF-e, mandar link pro contador e recarregar a página sem perder
            onde estava. */}
        <Route path="/fiscal/nota-avulsa/:id" element={<NotaAvulsaPage />} />
        <Route path="/fiscal/mensagens" element={<MensagensFiscais />} />
        <Route path="/industrial/maquinas" element={<IndMaquinasPage />} />
        <Route path="/industrial/moldes" element={<IndMoldesPage />} />
        <Route path="/industrial/etapas" element={<IndEtapasPage />} />
        <Route path="/industrial/dashboard" element={<DashboardIndustrial />} />
        <Route path="/industrial/indicadores" element={<IndicadoresIndustriaisPage />} />
        <Route path="/industrial/turnos" element={<IndTurnosPage />} />
        <Route path="/ajuda" element={<AjudaPage />} />
        <Route path="/industrial/sos" element={<SOSPanelPage />} />
        <Route path="/industrial/lotes" element={<LotesPage />} />
        <Route path="/industrial/manutencao" element={<ManutencaoPage />} />

        <Route path="/expedicao/veiculos" element={<ExpedicaoVeiculosPage />} />
        <Route path="/expedicao/motoristas" element={<ExpedicaoMotoristasPage />} />
        <Route path="/expedicao/rotas" element={<ExpedicaoRotasPage />} />
        <Route path="/expedicao/mdfe" element={<ExpedicaoMDFePage />} />
        <Route path="/expedicao/cargas" element={<CargasDistribuicaoPage />} />
        <Route path="/expedicao/mapa" element={<MapaCargasPage />} />
        <Route path="/industrial/ordens" element={<OrdensProducaoPage />} />
        <Route path="/industrial/ordens/:id" element={<OrdemProducaoDetalhe />} />
        <Route path="/industrial/carga" element={<CargaProducaoPage />} />
        <Route path="/industrial/fichas" element={<IndFichasPage />} />
        <Route path="/industrial/fichas/:id" element={<IndFichaEditorPage />} />
        <Route path="/industrial/materias-primas" element={<IndMateriasPrimasPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/marketplace/resumo-financeiro-ml" element={<ResumoFinanceiroMLPage />} />

        <Route path="/configuracoes" element={<ConfiguracoesPage />} />
        <Route path="/configuracoes/ia" element={<IAConfigPage />} />
        <Route path="/configuracoes/serasa" element={<IntegracaoSerasaPage />} />

        <Route path="/superadmin" element={<RequireSuper><SuperAdminDashboard /></RequireSuper>} />
        <Route path="/superadmin/empresas" element={<RequireSuper><SuperAdminEmpresas /></RequireSuper>} />
        <Route path="/superadmin/billing" element={<RequireSuper><SuperAdminBilling /></RequireSuper>} />
        <Route path="/superadmin/grupos" element={<RequireSuper><SuperAdminGrupos /></RequireSuper>} />

        <Route path="/servicos" element={<OrdensServicoPage />} />
        <Route path="/servicos/novo" element={<NovaOSPage />} />
        <Route path="/servicos/:id" element={<OSDetalhePage />} />
        <Route path="/orcamentos" element={<OrcamentosPage />} />
        <Route path="/orcamentos/novo" element={<NovoOrcamentoPage />} />
        <Route path="/orcamentos/:id" element={<OrcamentoDetalhePage />} />
        <Route path="/bpm" element={<BPMPage />} />
        <Route path="/bpm/instancias/:id" element={<BPMInstanciaPage />} />
        <Route path="/bpm/processos/novo" element={<BPMProcessoEditor />} />
        <Route path="/bpm/processos/:id/editar" element={<BPMProcessoEditor />} />
        <Route path="/bpm/processos/:id/designer" element={<BPMDesignerPage />} />
        <Route path="/intranet" element={<IntranetPage />} />

        <Route path="/compras" element={<ComprasPage />} />
        <Route path="/compras/nf-entradas" element={<NFEntradasPage />} />
        <Route path="/compras/nfe-a-receber" element={<DFeEntradaPage />} />
        <Route path="/compras/intercompany" element={<IntercompanyPage />} />

        <Route path="/comercial/venda-geral" element={<VendaGeralPage />} />
        <Route path="/comercial/painel-auditoria" element={<PainelAuditoriaPage />} />
        <Route path="/comercial/rotas" element={<RotasComercialPage />} />
        <Route path="/comercial/sugestoes-compra" element={<SugestoesCompraPage />} />
        <Route path="/comercial/metas" element={<ComercialMetasPage />} />
        <Route path="/comercial/relatorios-gerenciais" element={<RelatoriosGerenciaisPage />} />
        <Route path="/comercial/relatorios-gerenciais/:chave" element={<RelatorioGerencialView />} />
        <Route path="/comercial/comissao-vendedor" element={<ComissaoVendedorPage />} />
        <Route path="/relatorios/giro-produtos" element={<GiroProdutosPage />} />

        <Route path="/sac" element={<SACPage />} />
        <Route path="/sac/configuracao" element={<SACConfigPage />} />
        <Route path="/controladoria" element={<ControladoriaPage />} />
      </Route>
      <Route path="/m" element={<RequireAuth><MobileLayout /></RequireAuth>}>
        <Route index element={<InventariosMobilePage />} />
        <Route path="inventarios" element={<InventariosMobilePage />} />
        <Route path="inventarios/:id" element={<InventarioDetalheMobilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}
